/*
 * File: c:\Users\j.mazat\Desktop\Autofi\autofi_backoffice\src\Content\Car\CarSinglePic\CarSinglePic.tsx
 * Project: c:\Users\j.mazat\Desktop\Autofi\autofi_backoffice
 * Created Date: Tuesday April 16th 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Tuesday April 16th 2024 4:35:01 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

import translator from "MultiLanguage/TranslationWrapper";
import Styles from "Content/Car/CarSinglePic/CarSinglePic.module.css";
import { useEffect, useState } from "react";
import CarService from "Services/Car/CarService";

type CarSinglePic = {
    id: string;
    Status: string;
    handleNavigation: Function;
}

export default function CarSinglePic(props: CarSinglePic) {
    const [picURI, setPicURI] = useState("/Default.jpg");

    useEffect(() => {
        CarService.getCarPictures(props.id, 0).then((res => {
            if (res)
                setPicURI(res.Pict.URI);
        }))
        .catch();
    }, []);

    return (
        <div className={`${Styles.pictureBox}`} onClick={() => props.handleNavigation()}>
            {
                props.Status === "SOLD" || props.Status === "RESERVED" ?
                <div className={`${Styles.carStatusHolder}`}>
                    <h2 className={props.Status === "SOLD" ? Styles.sold : Styles.reserved} >{translator.decode(`car.status.${props.Status.toLowerCase()}`).toUpperCase()}</h2>
                </div>
                : null
            }
            <img className={`${Styles.picture}`} src={picURI} alt={translator.decode("dynamic.carImage")} />
        </div>
    );
};
